import * as z from "zod";

export const sendTestSMSById = {
  name: "sendTestSMSById" as const,
  input: z.object({
    phoneNumber: z.string(),
    templateId: z.string(),
    customerId: z.string().optional(), // Optional customer ID for content generation
    orderNumber: z.string().optional(),
  }),
  output: z.object({ success: z.boolean(), errorText: z.string().optional() }),
};
